import { createReducer, on } from '@ngrx/store';

import { ImpersonationState } from '../auth-state.model';
import { INITIAL_IMPERSONATION_STATE } from '../auth-state.constants';
import { ImpersonationActions } from './impersonation.actions';

export const impersonationReducer = createReducer(
  INITIAL_IMPERSONATION_STATE,

  on(ImpersonationActions.connect, (state) => ({
    ...state,
    status: 'connecting',
    error: null,
  })),

  on(
    ImpersonationActions.connectSuccess,
    (_, { buyerCompany }): ImpersonationState => ({
      impersonatedBuyer: buyerCompany,
      status: 'connected',
      error: null,
    }),
  ),

  on(
    ImpersonationActions.connectFailure,
    (_, { error }): ImpersonationState => ({
      status: 'disconnected',
      impersonatedBuyer: null,
      error,
    }),
  ),

  on(ImpersonationActions.disconnect, (state) => ({
    ...state,
    status: 'disconnecting',
    error: null,
  })),

  on(
    ImpersonationActions.disconnectSuccess,
    (): ImpersonationState => INITIAL_IMPERSONATION_STATE,
  ),

  on(
    ImpersonationActions.rehydrate,
    (_, { buyerCompany }): ImpersonationState => ({
      impersonatedBuyer: buyerCompany,
      status: 'connected',
      error: null,
    }),
  ),
);
